import { render, staticRenderFns } from "./Itemrowdetail.vue?vue&type=template&id=4478cbc0"
import script from "./Itemrowdetail.vue?vue&type=script&lang=js"
export * from "./Itemrowdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports